<script>
  import { onMount } from "svelte";
  import {
    DataTable,
    TextInput,
    Modal as DangerModal,
    Select,
    SelectItem,
    ToolbarSearch,
    ToolbarContent,
    Toolbar,
  } from "carbon-components-svelte";
  import { fly } from "svelte/transition";
  //import GroupCell from "./components/GroupCell.svelte";
  import Button from "../../../lib/components/Button.svelte";
  //import SearchInput from "./components/SearchInput.svelte";
  import Modal from "../../../lib/components/Modal.svelte";
  import Header from "../../../lib/components/Header.svelte";
  import TrashCan16 from "carbon-icons-svelte/lib/TrashCan16";
  import Edit16 from "carbon-icons-svelte/lib/Edit16";

  import { fetchWithSession } from "lib/util/fetchWithSession.js";

  let baseHeaders = [
    { key: "username", value: "Name" },
    { key: "email", value: "E-Mail" },
    { key: "business_unit", value: "Business unit" },
    { key: "department", value: "Department" },
    { key: "groups.admin", value: "Permission(s)" },
    { key: "edit", value: "Edit", sort: false },
  ];
  let users = [];

  let deleteUserModalOpen = false;
  let createUserModalOpen = false;
  let username = "";
  let userFirstName = "";
  let userLastName = "";
  let useremail = "";
  let deleteUserObj = "";
  let confirmPassword = "";
  let searchUser = undefined;
  let department = "";
  let deleteUserInput = "";
  let selectedGroups = [];
  let selectedTeams = [];
  let selectedUserId = null;
  let errorUserExist = "";
  let regularUser = false;
  let userToDelete = "";
  let departments = [];
  let businessUnits = [];
  let searchValue = "";

  $: transformedUsers = users.map((user) => ({
    ...user,
    username: `${user.first_name} ${user.last_name}`,
    department: user.department?.name || "-",
    business_unit:
      departments.find((d) => d.id === user.department?.id)?.business_unit
        ?.name || "-",
  }));

  $: console.log({ searchValue });

  $: onSearch(searchValue, transformedUsers);

  function onSearch(searchValue, transformedUsers) {
    if (transformedUsers && searchValue) {
      const searchTerm = searchValue.toLowerCase();
      const filteredUsers = transformedUsers.filter((user) => {
        return (
          (user.username && user.username.toLowerCase().includes(searchTerm)) ||
          (user.department &&
            user.department.toLowerCase().includes(searchTerm)) ||
          (user.business_unit &&
            user.business_unit.toLowerCase().includes(searchTerm)) ||
          (user.email && user.email.toLowerCase().includes(searchTerm))
          //  ||
          // (user.groups.admin && user.groups.admin.toLowerCase().includes(searchTerm))
        );
      });
      searchUser = filteredUsers || [];
    } else {
      searchUser = transformedUsers || [];
    }
  }

  function deleteUser() {
    fetchWithSession(`/api/knextractor/users/${deleteUserObj}`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ password: confirmPassword }),
    })
      .then((res) => {
        //res.json()
        const isSuccess = res.ok;

        return res.json().then((data) => ({ data, isSuccess }));
      })
      .then(({ data, isSuccess }) => {
        if (isSuccess) {
          fetchUsers();
        } 
        deleteUserModalOpen = false;
      });
    username = "";
  }
  function isValidEmail(useremail) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(useremail);
  }

  const createUser = () => {
    fetchWithSession("/api/knextractor/users", {
      method: "POST",
      body: JSON.stringify({
        email: useremail,
        first_name: userFirstName,
        last_name: userLastName,
        department: department,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        createUserModalOpen = false;
        fetchUsers();
      });
  };

  const updateUser = () => {
    fetchWithSession(`/api/knextractor/users/${selectedUserId}`, {
      method: "PATCH",
      body: JSON.stringify({
        email: useremail,
        first_name: userFirstName,
        last_name: userLastName,
        department_id: department,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        createUserModalOpen = false;
        fetchUsers();
      });
  };

  function fetchUsers() {
    fetchWithSession(`/api/knextractor/users`)
      .then((response) => response.json())
      .then((data) => {
        users = data;
      });
  }

  function getBusinessUnits() {
    fetchWithSession("/api/knextractor/business-units/")
      .then((response) => response.json())
      .then((data) => {
        businessUnits = data;
      });
  }

  const handleOpenEditModal = (row) => {
    selectedUserId = row.id;
    department = row.department.id || departments[0].id;
    userFirstName = row.first_name;
    userLastName = row.last_name;
    useremail = row.email;
    createUserModalOpen = true;
  };

  const handleOpenCreateModal = () => {
    selectedUserId = null;
    department = departments[0].id;
    selectedTeams = [];
    selectedGroups = [];
    userFirstName = "";
    userLastName = "";
    useremail = "";
    createUserModalOpen = true;
  };

  function getDepartments() {
    fetchWithSession("/api/knextractor/departments")
      .then((response) => response.json())
      .then((data) => {
        departments = data.map((item) => ({
          id: item.id,
          text: item.name,
          business_unit: item.business_unit,
        }));
      });
  }

  onMount(() => {
    fetchUsers();
    getDepartments();
    getBusinessUnits();
  });

  $$restProps;
</script>

<Header section="Settings" breadcrumb="User Management">
  <!-- <SearchInput on:search={onSearch} /> -->
  <Button
    variant="secondary"
    iconLeft={true}
    setting={true}
    text="Add User"
    icon="plus"
    on:click={() => handleOpenCreateModal()}
  />
  <Button
    text="Back"
    icon="arrow_left"
    setting={true}
    variant="secondary"
    iconLeft={true}
    on:click={() => history.back()}
  />
</Header>

<section>
  <div class="header">
    <h1>USERS</h1>
  </div>
  <div class="user-list-table">
    {#if transformedUsers.length}
      <DataTable
        headers={regularUser
          ? baseHeaders
          : [...baseHeaders, { key: "remove", value: "Delete", sort: false }]}
        rows={searchUser}
        class="custom-table"
        sortable
      >
        <Toolbar>
          <ToolbarContent>
            <ToolbarSearch
              shouldFilterRows="false"
              persistent
              bind:value={searchValue}
            />
          </ToolbarContent>
        </Toolbar>
        <svelte:fragment slot="cell" let:row let:cell>
          <!-- {#if cell.key === "username"}
            {row.first_name} {row.last_name}
          {:else if cell.key === "department"}
            {cell.value.name}
          {:else if cell.key === "business_unit"}
            {departments.find(
              (department) => department.id === row.department.id
            )?.business_unit.name || "-"} -->
          {#if cell.key === "edit"}
            <button
              on:click={() => handleOpenEditModal(row)}
              class="edit-remove-btn"><Edit16 /></button
            >
          {:else if cell.key === "remove"}
            <button
              on:click={() => {
                deleteUserObj = row.id;
                username = row.first_name + " " + row.last_name;
                deleteUserModalOpen = true;
              }}
              class="edit-remove-btn"><TrashCan16 /></button
            >
          {:else}
            {cell?.value || "-"}
          {/if}
        </svelte:fragment>
      </DataTable>
    {/if}
  </div>
</section>


<Modal
  actions
  preventCloseOnClickOutside
  autowidth={true}
  bind:open={deleteUserModalOpen}
  modalHeading={`Delete User ${username}`}
  primaryButtonText="Delete"
  primaryButtonAction={() => {
    userToDelete = deleteUserInput;
    deleteUser();
  }}
  width={653}
  on:close={() => {
    deleteUserInput = "";
    errorUserExist = "";
  }}
>
  <div class="deleteModalBody">
    Do you really want to <span>delete</span> this user.<br />
    <span>Caution! This cannot be undone.</span>
  </div>
</Modal>

<Modal
  autowidth={true}
  preventCloseOnClickOutside
  bind:open={createUserModalOpen}
  modalHeading={selectedUserId ? `Edit User:${username}` : "Create User"}
  actions
  width={653}
  primaryButtonText={selectedUserId ? "Save" : "Create User"}
  primaryButtonAction={() => {
    if (!userFirstName || !userLastName || !isValidEmail(useremail)) return;
    selectedUserId ? updateUser() : createUser();
  }}
  primaryButtonNotAllow={!userFirstName ||
    !userLastName ||
    !isValidEmail(useremail)}
>
  <div>
    <TextInput labelText="First name" bind:value={userFirstName} />
    <TextInput labelText="Last Name" bind:value={userLastName} />
    <TextInput
      labelText="E-Mail"
      bind:value={useremail}
      invalid={!(isValidEmail(useremail) || !useremail)}
    />

    <Select labelText="Department" bind:selected={department}>
      {#each departments as departmentList}
        <SelectItem value={departmentList.id} text={departmentList.text} />
      {/each}
    </Select>
  </div>
</Modal>

<style>
  section {
    background: var(--pax-smoke);
    width: 100%;
    height: 100%;
    padding: 12px;
  }
  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 8px;
  }

  .header h1 {
    overflow: hidden;
    color: var(--pax-black);
    text-overflow: ellipsis;
    font-family: Inter;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
  }
  .edit-remove-btn {
    background: var(--pax-black);
    width: 30px;
    height: 30px;
    border-radius: 4px;
    display: grid;
    place-items: center;
  }
  :global(.cross-plus-icon) {
    rotate: 45deg;
  }
  .deleteModalBody {
    padding: 23px 0px 23px 0px;
    font-family: Inter;
    font-size: 14px;
  }
  .deleteModalBody span {
    font-weight: 700;
  }
  .deleteModalBody :last-child {
    color: var(--pax-orange);
  }
  :global(.user-list-table svg) {
    color: white;
  }
</style>
